export const FOLDER_PERMISSIONS_API_ROOT = 'item_folders';
export const USER_GROUP_SEARCH_API_ROOT = 'users_and_groups';
export const FOLDERS_KEY = 'FOLDER_PERMISSIONS';

// this creates a human readable version of the db_value
// => full_editor to Full Editor
export const ACCESS_LEVEL_NAMING_MAP = Object.values(window.APP_CONSTANTS.FOLDER_ACCESS_LEVEL_TYPES).reduce(
  (map: { [key: string]: string }, accessLevel: string) => ({
    ...map,
    [accessLevel]: accessLevel
      .split('_')
      .map((str) => `${str[0].toUpperCase()}${str.slice(1)}`) // capitalize
      .join(' '),
  }),
  {},
);
